import { type InsurerDetailsDataFragment } from '../../../../api/fragments/InsurerDetailsData';
import { type InsurerSettings } from '../../../../api/types';

export { default as CreateInsurerDetailsForm } from './CreateInsurerDetailsForm';
export { default as CreateInsurerFrom } from './CreateInsurerFrom';
export type { NewInsurerFormValues } from './CreateInsurerFrom';
export { default as EazyInsurerIntegration } from './EazyInsurerIntegration';
export { default as EditInsurerDetailsForm } from './EditInsurerDetailsForm';
export { default as EditInsurerForm } from './EditInsurerForm';
export { default as EmailInsurerIntegration } from './EmailInsurerIntegration';
export { default as InsuranceProductTypeForm } from './InsuranceProductTypeForm';
export { default as InsurerIntegration } from './InsurerIntegration';
export { default as useInsurerFormValidator } from './useInsurerFormValidator';

export type InsurerFormValues = InsurerSettings;

export type InsurerIntegrationValues = InsurerDetailsDataFragment['integration'];
